import React, { Component } from 'react'
import {
    ComposedChart,
    Bar,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts'
import { translateName } from '../../utils/i18n'

const COLORS = [
    '#4F46E5',
    '#22C55E',
    '#F97316',
    '#0EA5E9',
    '#EC4899',
    '#EAB308',
    '#6366F1',
    '#14B8A6',
]

const formatSI = (n) => {
    if (Math.abs(n) >= 1e9) return +(n / 1e9).toFixed(1) + 'G'
    if (Math.abs(n) >= 1e6) return +(n / 1e6).toFixed(1) + 'M'
    if (Math.abs(n) >= 1e3) return +(n / 1e3).toFixed(1) + 'k'
    return Math.round(n)
}

class MultiAxisBarChart extends Component {
    shouldComponentUpdate(nextProps) {
        return JSON.stringify(this.props) !== JSON.stringify(nextProps)
    }

    render() {
        const { h, w, data = [], dataKeys, defaultKeys = [], className = 'MultiAxisBarChart', absolute = false, axisHeight = 60, language } = this.props

        const keys = dataKeys || defaultKeys

        if (keys.length < 2 || typeof keys[0] !== 'string') {
            return <div className={className}>Error: Provide a valid keys format.</div>
        }

        const xKey = keys[0]
        const seriesKeys = keys.slice(1)

        const leftKeys = seriesKeys.filter(k => k.axis === 'left')
        const rightKeys = seriesKeys.filter(k => k.axis === 'right')

        const processedData = data.map(d => {
            const newRow = { ...d }
            seriesKeys.forEach(k => {
                if (absolute || k.absolute) {
                    newRow[k.path] = Math.abs(d[k.path] || 0)
                }
            })
            return newRow
        })

        return (
            <div className={className} style={{ width: w, height: h }}>
                <ResponsiveContainer width="100%" height="100%">
                <ComposedChart data={processedData}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis
                        dataKey={xKey}
                        tick={{ angle: -35, textAnchor: 'end', fontSize: 10 }}
                        interval={0}
                        height={axisHeight}
                    />
                    {leftKeys.length > 0 && (
                        <YAxis
                            yAxisId="left"
                            orientation="left"
                            tickFormatter={formatSI}
                            stroke="#888888"
                            fontSize={10}
                        />
                    )}
                    {rightKeys.length > 0 && (
                        <YAxis
                            yAxisId="right"
                            orientation="right"
                            tickFormatter={formatSI}
                            stroke="#888888"
                            fontSize={10}
                        />
                    )}
                    <Tooltip
                        formatter={(value, name, props) => {
                            const keyObj = seriesKeys.find(k => k.path === props.dataKey)
                            const label = keyObj ? translateName(keyObj.tKey, language) : name
                            return [typeof value === 'number' ? Math.round(value) : value, label]
                        }}
                    />
                    <Legend
                        verticalAlign="top"
                        align="center"
                        wrapperStyle={{ paddingBottom: 10 }}
                        formatter={(value) => {
                            const keyObj = seriesKeys.find(k => k.path === value)
                            return keyObj ? translateName(keyObj.tKey, language) : value
                        }}
                    />
                    {seriesKeys.filter(k => k.type === 'bar').map((key) => {
                        const color = key.color || COLORS[seriesKeys.indexOf(key) % COLORS.length]
                        return (
                            <Bar
                                key={key.path}
                                dataKey={key.path}
                                yAxisId={key.axis || 'left'}
                                fill={color}
                                isAnimationActive={true}
                            />
                        )
                    })}
                    {seriesKeys.filter(k => k.type === 'line').map((key) => {
                        const color = key.color || COLORS[seriesKeys.indexOf(key) % COLORS.length]
                        return (
                            <Line
                                key={key.path}
                                type="monotone"
                                //type="linear"
                                dataKey={key.path}
                                yAxisId={key.axis || 'left'}
                                stroke={color}
                                strokeWidth={2}
                                dot={{ r: 3 }}
                                isAnimationActive={true}
                            />
                        )
                    })}
                </ComposedChart>
                </ResponsiveContainer>
            </div>
        )
    }
}

export default MultiAxisBarChart
